module.exports = __webpack_public_path__ + "img/notifications.ea78db3e.svg";